/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_Debt_TypeInputs */

const en_case_field_debt_type = /** @type {(inputs: Case_Field_Debt_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Debt type`)
};

const pt_br2_case_field_debt_type = /** @type {(inputs: Case_Field_Debt_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de débito`)
};

/**
* | output |
* | --- |
* | "Debt type" |
*
* @param {Case_Field_Debt_TypeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_debt_type = /** @type {((inputs?: Case_Field_Debt_TypeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_Debt_TypeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_debt_type(inputs)
	return pt_br2_case_field_debt_type(inputs)
});